import { z } from 'zod'

export const bookingReferrerSchema = z.enum(['topic-select', 'subscribes', 'home', 'reserved-lessons', 'paid-trial'])

export const bookingUrlParamsSchema = z.object({
  classId: z.union([z.string(), z.number()]),
  type: z.enum(['new', 'edit']),
  classType: z.enum(['trial', 'regular']),
  teacherId: z.union([z.string(), z.number()]).optional(),
  referrer: bookingReferrerSchema.optional(),
  /** 튜터 지정 레슨의 시간 변경 여부 (지정권 유지, 해당 튜터 가능 시간만 노출) */
  designated: z.boolean().optional(),
  /** 지정 레슨에서 유지할 튜터 ID */
  tutorId: z.union([z.string(), z.number()]).optional(),
})

export type BookingParams = z.infer<typeof bookingUrlParamsSchema>
